<template>
  <v-card>
    <v-toolbar>
      <v-toolbar-title>Point Events</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-data-table
        :headers="pointsSummaryHeaders"
        :items="pointsSummary"
        :items-per-page="30"
        dense
        class="mt-2 elevation-2 row-pointer"
      >
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { USER_REWARDS_POINTS_QUERY } from "@/graphql/queries/user";

export default {
  name: "ClientRewardPointEvents",
  props: {
    userId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      loading: true,
      pointsSummary: [],
      pointsSummaryHeaders: [
        { text: "Event Date", value: "eventDate" },
        { text: "Approval Status", value: "approvalStatus" },
        { text: "Description", value: "description" },
        { text: "Points", value: "points" },
        { text: "Decline dReason", value: "declinedReason" },
      ],
    };
  },
  apollo: {
    rewardPoints: {
      query: USER_REWARDS_POINTS_QUERY,
      variables() {
        let encoded_json_payload = btoa("UserNode:" + this.userId);
        return {
          userId: encoded_json_payload,
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          this.loading = false;
          response.data.rewardPoints.edges.forEach((row) => {
            this.pointsSummary.push({
              eventDate: row.node.eventDate,
              approvalStatus: row.node.approvalStatus,
              description: row.node.description,
              points: row.node.points,
              declinedReason: row.node.declinedReason,
            });
          });
        }
      },
    },
  }
};
</script>
